import { FormGroup, Input, Label } from "reactstrap";
import { H5, P } from "../../../../AbstractElements";
import { USER_INFO_DATAS } from "../../../../Data/Dashboard";
import { useState } from "react";
import { UserInformationToggleAction } from "./UserInformationToggleAction";
import { UserInformationName } from "./UserInformationName";

export const UserInformationTableBody = () => {
  const [data, setData] = useState(USER_INFO_DATAS);

  const deletHandler = (key: number) => {
    setData(data.filter((item) => item.id !== key));
  };

  return (
    <tbody>
      {data.map((value, number) => (
        <tr key={number}>
          <td>
            <FormGroup check>
              <Input id={`flexCheckDefault${value.id}`} type="checkbox" defaultValue="" />
              <Label check htmlFor={`flexCheckDefault${value.id}`} />
            </FormGroup>
          </td>
          <UserInformationName image={value.image} title={value.title} spanText={value.spanText}/>
          <td><P>{value.email}</P></td>
          <td className={`font-${value.color} f-w-500`}>{value.status}</td>
          <td><H5>{value.role}</H5></td>
          <UserInformationToggleAction deletHandler={deletHandler} id={value.id} />
        </tr>
      ))}
    </tbody>
  );
};
